import React from "react";
import PropTypes from "prop-types";
import { NextPageContext } from "next";
import dynamic from "next/dynamic";

import isMobile from "@utils/isMobile";
import { NextPageExtended } from "@interfaces/index";

import withDynamicModules from "@store/dynamic/withDynamicModules";

import indexModule from "@store/indexModule";
import analyticsModule from "@analytics/bike/index";

import { checkIfGPay } from "@utils/bike/bikeGpay";
import { gpayBikePath } from "@utils/landing-page-config";
// import { useRouter } from "next/router";

import proposalDataModule from "@store/moData/proposalData";
import mmvDataModule from "@store/mmvData";
import errorDataModule from "@store/errorData";

const MMVSelector = dynamic(() => import("@components/Bike/mmv/mmvD2c"), {
  ssr: true
});

const MMVSelectorOld = dynamic(() => import("@components/Bike/mmv/mmvGpay"), {
  ssr: true
});

const DesktopHeader = dynamic(() => import("@components/header/desktop"), {
  ssr: true
});

const MobileHeader = dynamic(() => import("@components/header/mobile"), {
  ssr: true
});

interface Props {
  isMobile: boolean;
  isGpay: boolean;
}

const MMV: NextPageExtended<Props> = ({ isMobile, isGpay }) => {
  // in case of SSR isGpay will be computed on server and in case of client we will compute using util
  const Header = isMobile ? MobileHeader : DesktopHeader;
  // const router = useRouter();
  // const { flow } = router.query;
  const isGpayBike = isGpay === undefined ? checkIfGPay() : isGpay;
  const MMVPage = isGpayBike ? MMVSelectorOld : MMVSelector;
  return (
    <>
      <Header showBackNavigator />
      <MMVPage />
    </>
  );
};

MMV.getInitialProps = async (ctx: NextPageContext) => {
  let isGpay;
  if (ctx.req && ctx.req?.headers["x-landing-path"]) {
    isGpay = ctx.req?.headers["x-landing-path"] === gpayBikePath;
  }
  return {
    isMobile: isMobile(ctx.req),
    isGpay: isGpay
  };
};

MMV.propTypes = {
  isMobile: PropTypes.bool.isRequired
};

// export default MMV;
export default withDynamicModules(MMV, [
  mmvDataModule(),
  proposalDataModule(),
  indexModule(),
  analyticsModule(),
  errorDataModule()
]);
